<template>
  <main class="blocking-error">
    <div class="blocking-error__body">
      <h1 class="blocking-error__title">{{ title }}</h1>
      <p class="blocking-error__message">{{ message }}</p>
      <strong class="blocking-error__code">Error {{ code }}</strong>
    </div>
    <a
      class="blocking-error__logo-holder"
      href="https://feedbackcompany.com"
      title="Go to the Feedback Company website"
    >
      <FeedbackCompanyLogo />
    </a>
  </main>
</template>

<script>
import BaseComponent from "../BaseComponent";
import FeedbackCompanyLogo from "../atoms/FeedbackCompanyLogo.vue";

/**
 * @vuese
 * This Error blocks the whole app as it overlays over everything else.
 * This only needs to be displayed when something critical went wrong.
 */
export default {
  name: "BlockingError",
  mixins: [BaseComponent],
  components: { FeedbackCompanyLogo },
  props: {
    // Error Code, displays to user
    code: {
      required: true,
      type: String,
    },
    // Error Message, displays to user
    message: {
      required: true,
      type: String,
    },
    title: {
      type: String,
      default: "Error, something went wrong.",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../style_variables/style_variables.scss";
.blocking-error {
  width: 100vw;
  height: 100vh;
  padding: 36px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: fixed;
  top: 0px;
  left: 0px;
  background-color: $white;
  z-index: 100;

  &:after {
    position: absolute;
    bottom: 0px;
    content: "";
    width: 100%;
    height: 12px;
    background-color: $red;
  }
}
.blocking-error__body {
  width: 500px;
  max-width: 100%;
  padding: 50px 50px 50px 32px;
  @media (max-width: 769px) {
    padding: 0px;
  }
}
.blocking-error__icon {
  color: $red;
  font-size: 32px;
}
.blocking-error__title {
  @extend %headline5_style;
  color: $red;
  margin: 0px;
}
.blocking-error__message {
  @extend %body1_style;
  color: $grey_mineshaft;
}
.blocking-error__code {
  @extend %body1_style;
  display: inline-block;
  color: $grey_french;
}
.blocking-error__logo-holder {
  position: absolute;
  bottom: 8vh;
  margin-top: 2vh;
  filter: grayscale(100%);
  opacity: 0.3;
  transition: 170ms all;
  &:hover {
    filter: grayscale(0%);
    opacity: 1;
  }
}
</style>
